import * as authActions from 'actions/authentication';

const initialState = {
  fetchingBackground: true,
  user: null,
  role: null,
  permissions: [],
  ACLUsers: [],
  fetchingUserRole: false,
  loading: false,
  loginError: {},
  registerError: {},
  resetError: {},
  resetLinkSent: false,
  resetEmailAddress: undefined,
  didResetPassword: false,
  resetConfirmationError: {},
  userCreated: false,
  creatingUser: false,
  formData: {
    'reset-confirm': undefined,
    login: { email: '', password: '' },
    register: { firstName: '', lastName: '', email: '', password: '' },
    'assign-manager': { fullName: '', email: '', pwd: '' },
  },
  hasVenues: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case authActions.SET_HAS_VENUES:
      return { ...state, ...action.payload };
    case authActions.REQUEST_LOGIN_SUBMISSION:
      return { ...state, ...action.payload };
    case authActions.RECEIVE_LOGIN_SUBMISSION:
      return { ...state, ...action.payload };
    case authActions.REQUEST_REGISTER_SUBMISSION:
      return { ...state, ...action.payload };
    case authActions.RECEIVE_REGISTER_SUBMISSION:
      return { ...state, ...action.payload };
    case authActions.REQUEST_PASSWORD_RESET:
      return { ...state, ...action.payload };
    case authActions.RECEIVE_PASSWORD_RESET:
      return { ...state, ...action.payload };
    case authActions.REQUEST_PASSWORD_RESET_DETAILS:
      return { ...state, ...action.payload };
    case authActions.RECEIVE_PASSWORD_RESET_DETAILS:
      return {
        ...state,
        ...action.payload,
        formData: {
          ...state.formData,
          'confirm-reset': { email: action.payload.resetEmailAddress },
        },
      };
    case authActions.REQUEST_PASSWORD_RESET_CONFIRM:
      return { ...state, ...action.payload };
    case authActions.RECEIVE_PASSWORD_RESET_CONFIRM:
      return { ...state, ...action.payload };
    // case authActions.CREATING_USER:
    //   return { ...state, ...action.payload };
    // case authActions.USER_CREATED:
    //   return { ...state, ...action.payload };
    case authActions.REQUEST_CREATE_USER:
      return { ...state, ...action.payload };
    case authActions.SET_ACL_USERS:
      return { ...state, ...action.payload };
    case authActions.UPDATE_ACL_USER:
      return { ...state, ...action.payload };
    case authActions.DELETE_ACL_USER:
      return { ...state, ...action.payload };
    case authActions.REQUEST_USER_ROLE:
      return { ...state, ...action.payload };
    case authActions.RECEIVE_USER_ROLE:
      return { ...state, ...action.payload };
    case authActions.CLEAR_AUTH_FLAGS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/reducers/authentication/index.js